export const getImage = (name: string = ''): any => {
  let image: any = ''

  if (!name.trim().length) {
    return image
  }

  if (process.env.NODE_ENV === 'production') {
    image = require(`./images/${name}`)
    return image.default
  }

  return image
}
